"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexColumn, FormControl, TextBody } from "@opensea/ui-kit";
import { useFormContext, useFormState, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { WalletAddressInput } from "../../../../../components/WalletAddressInput";
import { useAddressInputField } from "../../../../../hooks/useAddressInput";
export const TransferFlowRecipient = () => {
  const $ = _c(31);
  const t = useTranslations("wallet.TransferFlowRecipient");
  const {
    register,
    setValue,
    control
  } = useFormContext();
  let t0;
  if ($[0] !== control) {
    t0 = {
      control
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    errors
  } = useFormState(t0);
  let t1;
  if ($[2] !== control) {
    t1 = {
      control,
      name: "recipient"
    };
    $[2] = control;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const recipient = useWatch(t1);
  let t2;
  if ($[4] !== recipient.identifier || $[5] !== setValue) {
    t2 = {
      field: "recipient",
      setValue,
      identifier: recipient.identifier
    };
    $[4] = recipient.identifier;
    $[5] = setValue;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const addressInputProps = useAddressInputField(t2);
  let t3;
  if ($[7] !== t) {
    t3 = t("sendTo");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <TextBody weight="semibold">{t3}</TextBody>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = recipient.isResolving ? undefined : errors.recipient?.identifier?.message ?? errors.recipient?.resolvedAddress?.message;
  let t6;
  if ($[11] !== t) {
    t6 = t("recipient");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("enterRecipientAddress");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== setValue) {
    t8 = value => setValue("recipient.identifier", value);
    $[15] = setValue;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== register) {
    t9 = register("recipient.identifier");
    $[17] = register;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== addressInputProps || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t10 = <WalletAddressInput autoFocus={true} placeholder={t7} setValue={t8} size="sm" {...addressInputProps} {...t9} />;
    $[19] = addressInputProps;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t5 || $[26] !== t6) {
    t11 = <FlexColumn className="gap-1"><FormControl error={t5} hideLabel={true} label={t6}>{t10}</FormControl></FlexColumn>;
    $[24] = t10;
    $[25] = t5;
    $[26] = t6;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t4) {
    t12 = <div className="grid grid-cols-2 items-center py-3.5">{t4}{t11}</div>;
    $[28] = t11;
    $[29] = t4;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};